export default "__VITE_ASSET__W8O7ydic__"